import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { MatChipsModule } from '@angular/material/chips';

@Component({
  selector: 'serial-no-cell',
  standalone: true,
  imports: [CommonModule, MatTooltipModule, ClipboardModule, MatChipsModule],
  template: `
    <div class="serial-no">
      <span
        matTooltip="{{ clipboardText }}"
        matTooltipPosition="below"
        [cdkCopyToClipboard]="data"
        (click)="clipbordClick($event); $event.stopPropagation()"
        class="serial-no-text cursor-pointer"
        [ngClass]="!data ? '' : ''"
        >{{ data || '-' }}</span
      >
    </div>
  `,
  styles: [
    `
      .serial-no {
        padding: 4px 8px;
        border-radius: 8px;
        border: 1px solid var(--bg-overlay);
        max-width: max-content;
        background-color: var(--bg-overlay);
      }

      .serial-no-text {
        font-family: var(--manrope);
        font-weight: 500;
        color: var(--text-primary);
        font-size: 14px;
      }

      .inactive {
        padding: 4px 10px;
      }
    `,
  ],
})
export class SerialNoCellComponent {
  @Input() data: any;

  public clipboardText: string = 'Click to copy';

  clipbordClick(event: any) {
    this.clipboardText = 'Sl.no. copied';
  }
}
